import React from "react";

const BlankOverlay = props => {
    return null;
}

export default BlankOverlay